import 'react-toastify/dist/ReactToastify.css'

import TableDeleteFiles from '../../../components/table/files/TableDeleteFiles'

const DeleteDocument = () => {
  return <TableDeleteFiles />
}

export default DeleteDocument
